// Mark 03, "The Ring": twelve people around one lens.
// Drawn on a 48px grid — dot centres sit on r=17, the pupil is r=7.
const RING = [
  [41, 24], [38.72, 32.5], [32.5, 38.72], [24, 41],
  [15.5, 38.72], [9.28, 32.5], [7, 24], [9.28, 15.5],
  [15.5, 9.28], [24, 7], [32.5, 9.28], [38.72, 15.5],
] as const;

export function Logo({ size = 26, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      {RING.map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={2.4} fill={color} />
      ))}
      <circle cx={24} cy={24} r={7} fill={color} />
    </svg>
  );
}

export function Wordmark({ size = 26 }: { size?: number }) {
  return (
    <span className="wordmark">
      <Logo size={size} />
      <span>Everyone&rsquo;s Camera</span>
    </span>
  );
}
